import { ResponsiveCard } from '../../molecules/card/Card';

export function OsasSleepTipsCard() {
    return (
        <ResponsiveCard
            body="Ontdek hoe je beter kunt slapen met deze tips"
            cardTitle="Tips om beter te slapen"
            icon="download"
            lg={12}
            linksText={['Tips om beter te slapen']}
            linksTo={['/assets/documents/Sleep_tips.pdf']}
            openInNewTab
            position="left"
        />
    );
}
